import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@contexts/AuthContext';
import { clsx } from 'clsx';

const getInitials = (label: string) =>
  label
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

export const UserMenu: React.FC = () => {
  const { admin, logout } = useAuth();

  if (!admin) return null;

  const displayName =
    admin.firstName || admin.lastName ? `${admin.firstName ?? ''} ${admin.lastName ?? ''}`.trim() : admin.username;

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center justify-center h-9 w-9 rounded-full bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 transition-colors">
        {getInitials(displayName) || admin.username[0]?.toUpperCase()}
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-150"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-lg bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-lg shadow-gray-200/50 dark:shadow-none focus:outline-none z-30">
          <div className="px-4 py-3 border-b border-gray-100 dark:border-gray-700">
            <p className="text-sm font-medium text-gray-900 dark:text-white truncate">{displayName}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{admin.email}</p>
          </div>
          <div className="p-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={logout}
                  className={clsx(
                    'flex w-full items-center gap-2 px-3 py-2 text-sm rounded-md text-danger-600 dark:text-danger-400',
                    active && 'bg-danger-50 dark:bg-danger-900/20'
                  )}
                >
                  <ArrowRightOnRectangleIcon className="h-4 w-4" />
                  Logout
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
